import { createRoutine } from 'redux-saga-routines';

export const syncSchedule = createRoutine('SYNC_SCHEDULE');
export const stopSyncingSchedule = createRoutine('STOP_SYNCING_SCHEDULE');
export const toggleHidePastEvents = createRoutine('TOGGLE_HIDE_PAST_EVENTS');
export const setItineraryListVisibility = createRoutine('SET_ITINERARY_LIST_VISIBILITY');

export const saveScheduleListBackground = createRoutine('SAVE_SCHEDULE_LIST_BACKGROUND');
export const saveScheduleDetailsBackground = createRoutine('SAVE_SCHEDULE_DETAILS_BACKGROUND');
export const removeScheduleImage = createRoutine('REMOVE_SCHEDULE_IMAGE');
export const publishImportedSessions = createRoutine('PUBLISH_IMPORTED_SESSIONS');
